
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { PlanRequest } from "../../domain/requests/plans/plan.request";
import { AttachSchedulerRequest, Plan } from "../../domain";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class AttachSchedulerUsecase implements UseCase<AttachSchedulerRequest, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: AttachSchedulerRequest): Observable<boolean> {
    return this.planRepository.attachScheduler(params);
  }

}